import { axios } from '@Root/API'

export const getAll = (contactId, params) => {
	return axios.get(`engagement/${contactId}/student-registration/list`, { params })
}
